import React from 'react'
import { TextAreaSC } from './textarea.styled'

interface ITextAreaProps {
  placeholder: string
  labelId: string
  onChangeHandler: (e: string) => void
  value: string
}

const TextArea: React.FC<ITextAreaProps> = ({ placeholder, onChangeHandler, value }) => {
  const handleInputChange = (e: React.FormEvent<HTMLTextAreaElement>) => {
    onChangeHandler(e.currentTarget.value)
  }

  return (
    <TextAreaSC placeholder={placeholder} onChange={handleInputChange} value={value} id='txtArea' />
  )
}

export default TextArea
